import React, {useState} from "react";
import {css} from "@emotion/css";
import {Alert, AlertTitle} from "@mui/lab";
import {FormControl, Grid} from "@mui/material";
import RaikoMaterialOutlinedInput from "../../raikoComponents/raikoInputs/RaikoMaterialOutlinedInput";
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import {setLoadingStateDispatch, useLoadingDispatcher} from "../../context/LoadingContext";
import {setSnackbarDispatch, SnackbarActionTypes, useSnackbarDispatcher} from "../../context/SnackBarContext";
import {useAuthDispatcher, useAuthState} from "../../context/AuthContext";
import {useNavigate} from "react-router-dom";
import {doUserLoginOut} from "../Sidebar/LogOut";

const ChangeUserName = (
    {
        adminId = -1,
        service,
        hint = "بعد از تغییر نام کاربری به صورت خودکار از برنامه خارج می شوید و لازم است مجددا با نام کاربری جدید وارد برنامه شوید.",
        refreshDetailInfo
    }) => {

    const loading = useLoadingDispatcher()
    const snackbar = useSnackbarDispatcher()

    const [username, setUsername] = useState("");

    const navigate = useNavigate()
    const dispatch = useAuthDispatcher()


    function changeUserName() {
        if (username.length > 7) {
            loading(setLoadingStateDispatch(true))

            if (adminId >= 0)
                updateManagerUserName()
            else
                updateOwnAdminUsername()


        } else {
            snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, "نام کاربری باید حداقل 8 کاراکتر باشد!"))
        }
    }

    function updateManagerUserName() {
        service.updateManagerUserNameById(adminId, username)
            .then(response => {
                loading(setLoadingStateDispatch(false))
                if (refreshDetailInfo)
                    refreshDetailInfo()
                setUsername("")
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "نام کاربری با موفقیت تغییر پیدا کرد!"))
            }).catch(reason => {
            loading(setLoadingStateDispatch(false))

            if (reason.response.status === 409) {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "نام کاربری وارد شده تکراری می باشد!"))
            } else
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در تغییر نام کاربری"))
        })
    }

    function updateOwnAdminUsername() {
        service.updateUserName(username)
            .then(response => {
                loading(setLoadingStateDispatch(false))
                setUsername("")
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, "نام کاربری با موفقیت تغییر پیدا کرد!"))

                if (adminId === -1)
                    doUserLoginOut(dispatch, navigate)
            }).catch(reason => {
            loading(setLoadingStateDispatch(false))

            if (reason.response.status === 409) {
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "نام کاربری وارد شده تکراری می باشد!"))
            } else
                snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, "خطا در تغییر نام کاربری"))
        })
    }

    return (
        <section
            className={`default-card-container-background-style  ${css`
              padding: 16px;
              margin-top: 16px;
              display: flex;
              flex-direction: column;`}`}>
                    <span
                        className={css`
                          font-size: var(--text-size-large);
                          width: 100%;
                          flex-shrink: 0;
                          color: var(--color-text);
                        `}>
                        تغییر نام کاربری
                    </span>
            <Grid container spacing={"16px"} className={css`margin-top: 8px !important;`}>

                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Alert severity="error" className={css`width: 100%;`}>
                        <AlertTitle>لطفا نکات زیر را مورد توجه قرار دهید:</AlertTitle>
                        <div className={css`display: flex;
                          flex-direction: column;
                          gap: 8px;
                          margin-top: 16px;
                        `}>
                            <span>{hint}</span>

                        </div>
                    </Alert>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <FormControl fullWidth>
                        <RaikoMaterialOutlinedInput
                            labelText={"نام کاربری جدید"}
                            placeHolder={"لطفا کاربری مورد نظر را وارد نمایید..."}
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                        />
                    </FormControl>
                </Grid>
            </Grid>
            <div className={css`margin-top: 16px;
              display: flex;
              justify-content: left;`}>
                <ButtonPrimaryRaiko
                    onClick={changeUserName}
                    label={"بروزرسانی"}
                />
            </div>
        </section>
    )
}
export default ChangeUserName